import { noOp } from 'common/Constants';
import { StorageKeys } from 'common/storage/constants';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useLocalStorage } from 'src/shared/storage/Storage';
import { match } from 'ts-pattern';
import { UseFollowModalProps } from '../types';

/**
 * Hook for displaying following modal.
 */
export const useShowModal = (props: UseFollowModalProps) => {
  const { enableFollowModal = true, name, numFollowedShefs = 0, onHide = noOp } = props;
  const [isShowing, setIsShowing] = useState(false);
  const [isShowingTooltip, setIsShowingTooltip] = useState(false);
  const tooltipRef = useRef(0);
  const [hasSeenFeature, setHasSeenFeature] = useLocalStorage(StorageKeys.SHEF_FOLLOW_EXPLAINER_SEEN, false);

  useEffect(() => {
    return () => {
      clearTimeout(tooltipRef.current);
    };
  }, []);

  const showModal = useCallback(
    (justFollowedAShef?: boolean) => {
      const canShowFollowModal = match({
        hasSeenFeature,
        enableFollowModal,
        followsShefs: numFollowedShefs > 0,
        numFollowedShefs,
        justFollowedAShef,
      })
        .with({ hasSeenFeature: true }, () => false)
        .with({ enableFollowModal: false }, () => false)
        .with({ justFollowedAShef: true, numFollowedShefs: 1 }, () => true)
        .with({ followsShefs: true }, () => false)
        .otherwise(() => true);

      if (canShowFollowModal) {
        setIsShowing(true);
      } else {
        onHide();
      }
    },
    [enableFollowModal, hasSeenFeature, numFollowedShefs, onHide]
  );

  const onClose = () => {
    setIsShowing(false);
    onHide();
    setIsShowingTooltip(true);
    setHasSeenFeature(true);
    tooltipRef.current = window.setTimeout(() => {
      setIsShowingTooltip(false);
    }, 3000);
  };
  return { isShowing, isShowingTooltip, onClose, publicName: name, showModal };
};
